import useAPI from '@/hooks/useAPI';
import PersonRepository from '@/repositories/PersonRepository';

const useWarmingSequences = (enabled = true) => {
  const personRepository = PersonRepository();

  return useAPI({
    queryKey: ['getWarmingSequences'],
    queryFn: async () => {
      return await personRepository.getWarmingSequences();
    },
    enabled
  });
};

export default useWarmingSequences;
